import { render, staticRenderFns } from "./ChatRoomList.vue?vue&type=template&id=0aadd2bc&scoped=true&"
import script from "./ChatRoomList.vue?vue&type=script&lang=js&"
export * from "./ChatRoomList.vue?vue&type=script&lang=js&"
import style0 from "./ChatRoomList.vue?vue&type=style&index=0&id=0aadd2bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aadd2bc",
  null
  
)

export default component.exports